import PropTypes from 'prop-types';
import React from 'react';
import OtherField from '../shared/OtherField';
import SelectListControl from './SelectListControl';
import SurveyAttachment from '../attachment/SurveyAttachment';
import SimpleLogicList from '../../survey_editor/preview/SimpleLogicList';
import classnames from 'classnames';

const SelectListItem = ({
  _type,
  className,
  based_on,
  checked,
  disabled,
  questionId,
  id,
  index,
  name,
  questionName,
  onChange,
  other,
  text,
  value,
  logic = [],
  pages,
}) => (
  <li
    className={classnames('chc radio pl0', {
      'based-on': based_on,
      'bt b--black-10': index !== 0,
    })}
    key={name}
  >
    <SurveyAttachment id={id} size="thumb" inlineVideo={false} />
    <label className="d-b pv2 mv0">
      <SelectListControl
        className={className}
        disabled={disabled}
        _type={_type}
        checked={checked}
        id={`questions_${questionName}_${name}`}
        label={text}
        name={name}
        onChange={onChange}
        questionId={questionId}
        type={_type === 'Survey::SingleSelect' ? 'radio' : 'checkbox'}
        value={value}
      />{' '}
      {other ? (
        <OtherField
          className="mb0"
          disabled={disabled}
          name={`questions[${questionName}-other-value]`}
          placeholder="Please specify"
          questionId={questionId}
          type="text"
        />
      ) : null}
      <SimpleLogicList logic={logic} pages={pages} />
    </label>
  </li>
);

SelectListItem.propTypes = {
  _type: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  questionId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  questionName: PropTypes.string.isRequired,
  other: PropTypes.bool,
  text: PropTypes.string,
  value: PropTypes.string,
};

export default SelectListItem;
